export default {
  PROBLEMS: 1,
  DOUBTS: 2,
  TRAINING: 3,
  OFFER: 4,
  ACTION_PLAN: 5
}
